/* Essential PDP: progressive enhancement; native Shopify forms own cart submission. */
(() => {
  'use strict';
  if (window.PBEssentialPDP) { window.PBEssentialPDP.init(document); return; }
  const instances = new WeakMap();
  function mount(root) {
    if (instances.has(root)) return;
    const configNode = root.querySelector('[data-pb-config]');
    if (!configNode) return;
    let config;
    try { config = JSON.parse(configNode.textContent); } catch (_) { return; }
    const abort = new AbortController();
    const on = (target, event, listener) => target.addEventListener(event, listener, { signal: abort.signal });
    const variants = new Map(config.variants.map(v => [String(v.id), v]));
    const selects = [...root.querySelectorAll('[data-pb-select]')];
    const buttons = [...root.querySelectorAll('[data-pb-variant]')];
    const stage = root.querySelector('[data-pb-gallery-stage] img');
    const thumbs = [...root.querySelectorAll('[data-pb-thumb]')];
    const gallerySources = thumbs.map(b => {
      const img = b.querySelector('img');
      return {src: b.dataset.pbFull || img?.getAttribute('src'), alt: img?.alt || 'Essential Adjustable Base'};
    });
    let galleryIndex = Math.max(0, thumbs.findIndex(b => b.getAttribute('aria-pressed') === 'true'));
    function setImage(image, source, alt) {
      if (!image || !source) return;
      image.removeAttribute('srcset'); image.removeAttribute('sizes');
      image.src = source; image.alt = alt;
    }
    function gallery(index) {
      if (!gallerySources.length) return;
      galleryIndex = (index + gallerySources.length) % gallerySources.length;
      const selected = gallerySources[galleryIndex];
      setImage(stage, selected.src, selected.alt);
      thumbs.forEach((b, i) => { b.classList.toggle('active', i === galleryIndex); b.setAttribute('aria-pressed', String(i === galleryIndex)); });
    }
    function selectVariant(id, updateURL) {
      const variant = variants.get(String(id));
      if (!variant) return;
      selects.forEach(select => { select.value = String(variant.id); });
      buttons.forEach(button => { const active = button.dataset.pbVariant === String(variant.id); button.classList.toggle('selected', active); button.setAttribute('aria-pressed', String(active)); });
      root.querySelectorAll('[data-pb-price]').forEach(node => { node.textContent = variant.price; });
      root.querySelectorAll('[data-pb-compare]').forEach(node => { node.hidden = !variant.compare; node.querySelector('span').textContent = variant.compare || ''; });
      root.querySelectorAll('[data-pb-saving]').forEach(node => { node.hidden = !variant.saving; node.textContent = variant.saving ? `SAVE ${variant.saving}` : ''; });
      root.querySelectorAll('[data-pb-atc]').forEach(button => { button.disabled = !variant.available; button.textContent = variant.available ? 'Add to Cart' : 'Sold out'; });
      if (variant.image) { setImage(stage, variant.image, `${config.productTitle || 'Essential Adjustable Base'} — ${variant.title}`); thumbs.forEach(b => { b.classList.remove('active'); b.setAttribute('aria-pressed','false'); }); }
      if (updateURL) {
        const url = new URL(window.location.href); url.searchParams.set('variant', String(variant.id)); window.history.replaceState({}, '', url);
      }
      root.dispatchEvent(new CustomEvent('pb:variant-change', {bubbles:true,detail:{variant,sectionId:root.dataset.sectionId}}));
    }
    thumbs.forEach((button, i) => on(button, 'click', () => gallery(i)));
    const galleryStage = root.querySelector('[data-pb-gallery-stage]');
    let touchX = null;
    if (galleryStage) {
      on(galleryStage, 'touchstart', event => { touchX = event.touches.length === 1 ? event.touches[0].clientX : null; });
      on(galleryStage, 'touchend', event => { if (touchX === null) return; const dx = event.changedTouches[0].clientX - touchX; if (Math.abs(dx)>55) gallery(galleryIndex + (dx<0?1:-1)); touchX=null; });
    }
    selects.forEach(select => on(select, 'change', () => selectVariant(select.value, true)));
    buttons.forEach(button => {
      button.dataset.unavailable = String(!variants.get(button.dataset.pbVariant)?.available);
      on(button, 'click', () => { selectVariant(button.dataset.pbVariant, true); selects.forEach(select => select.dispatchEvent(new Event('change',{bubbles:true}))); });
    });
    on(window, 'popstate', () => selectVariant(new URL(window.location.href).searchParams.get('variant') || config.selectedVariantId, false));
    const initialID = new URL(window.location.href).searchParams.get('variant');
    selectVariant(variants.has(initialID) ? initialID : config.selectedVariantId, false);
    // Keep the native select in the form so no-JS purchases and third-party listeners work.
    selects.forEach(select => { select.classList.add('pb-sr-only'); select.tabIndex = -1; select.setAttribute('aria-hidden','true'); });
    root.querySelectorAll('[data-pb-variant-buttons]').forEach(group => { group.hidden=false; });
    const positionButtons = [...root.querySelectorAll('[data-pb-position]')];
    positionButtons.forEach(button => on(button, 'click', () => {
      const name=button.dataset.pbPosition;
      setImage(root.querySelector('[data-pb-position-stage] img'),config.positions[name],button.textContent.trim()+' position');
      positionButtons.forEach(b=>{const active=b===button;b.classList.toggle('active',active);b.setAttribute('aria-pressed',String(active));});
    }));
    const dialog = root.querySelector('[data-pb-delivery-dialog]');
    const opener = root.querySelector('[data-pb-delivery]');
    if(dialog && opener){on(opener,'click',()=>dialog.showModal());on(dialog.querySelector('[data-pb-close]'),'click',()=>dialog.close());on(dialog,'click',e=>{if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close();}});}
    // Native POST handles server-side price/inventory validation and cart errors.
    // No custom AJAX request is added; host-theme integrations may enhance these forms.
    instances.set(root,abort);
  }
  function init(scope){if(scope.matches?.('[data-pb-essential]'))mount(scope);scope.querySelectorAll?.('[data-pb-essential]').forEach(mount);}
  function unmount(scope){const roots=[...(scope.matches?.('[data-pb-essential]')?[scope]:[]),...scope.querySelectorAll('[data-pb-essential]')];roots.forEach(root=>{instances.get(root)?.abort();instances.delete(root);});}
  window.PBEssentialPDP={init};
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(document),{once:true});else init(document);
  document.addEventListener('shopify:section:load',event=>init(event.target));
  document.addEventListener('shopify:section:unload',event=>unmount(event.target));
})();
